import type { AvatarProps } from '../components/AwAvatar.vue'
import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import icons from '../styles/icons'

export interface UseComponentIconsProps {
  icon?: string
  avatar?: AvatarProps
  isLeading?: boolean
  leadingIcon?: string
  isTrailing?: boolean
  trailingIcon?: string
  isLoading?: boolean
  loadingIcon?: string
}

export function useComponentIcons(componentProps: MaybeRefOrGetter<UseComponentIconsProps>, slots?: { leading?: () => any, trailing?: () => any }) {
  const props = computed(() => toValue(componentProps))

  const isLeading = computed(() => (props.value.icon && props.value.isLeading) || (props.value.icon && !props.value.isTrailing) || (props.value.isLoading && !props.value.isTrailing) || !!props.value.leadingIcon || !!slots?.leading)
  const isTrailing = computed(() => (props.value.icon && props.value.isTrailing) || (props.value.isLoading && props.value.isTrailing) || !!props.value.trailingIcon || !!slots?.trailing)

  const leadingIconName = computed(() => {
    if (props.value.isLoading) {
      return props.value.loadingIcon || icons.loading
    }
    return props.value.leadingIcon || props.value.icon
  })
  const trailingIconName = computed(() => {
    if (props.value.isLoading && !isLeading.value) {
      return props.value.loadingIcon || icons.loading
    }
    return props.value.trailingIcon || props.value.icon
  })

  return {
    isLeading,
    isTrailing,
    leadingIconName,
    trailingIconName,
  }
}
